<mat-form-field appearance="fill" class="data-protection-rule-select">
    <mat-label>
      <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.dataProtectionRule"></sc-dictionary-label>
    </mat-label>
    <mat-select [formControl]="formControl" [required]="required">
        <mat-option *ngFor="let rule of dataProtectionRules" [value]="rule.id">
            {{rule.name}}
        </mat-option>
    </mat-select>
</mat-form-field>
